export default "__VITE_ASSET__CQt1YIXj__"